<template>
<a name="Bulletionnnn">
    <lazy-component @show.once="render(false)">
      <div class="mianv" v-if="list && list.length > 0">
        <ModuleTitle
        :title="'备注'"
        :desc="''"
        :rightArrow="false"
        :rightButton="'添加备注'"
        :rightButtonEvent="clickAsk"/>
        <div v-for="(item, index) in list"
              :key="index"
              @click="clickCell(item, index)"
              class="announcement linebottomg">
          <p class="announcement-text">{{item.content}}</p>
          <div class="announcement-info">
            <span class="announcement-time">{{getTime(item)}}</span>
          </div>
        </div>
          <!-- 更多 -->
        <ModuleButton class="spzModuleButton"
        :click="clickMore" :value="'更多备注'"/>
      </div>
    </lazy-component>
</a>
</template>

<script>
import Util from '@/base/Util';
// import dataModel from '@/model/announcement.model';
import StoreManger from '@/utils/FundHQJHManger';
// import separatorView from '@/components/SeparatorView.vue';
import ModuleButton from '@/components/ModuleButton.vue';
import ModuleTitle from '@/components/ModuleTitle.vue';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  name: 'FundAnnouncement',
  components: {
    ModuleButton,
    ModuleTitle,
  },
  data() {
    return {
      isShow: true,
      testData: [{
        content: '标题标题标题标题标题标题标题标题标题标题标题标题标题标题？',
        showTime: '2021-01-22 10:21:01',
      },
      {
        content: '标题标题标题标题标题标题标题标题标题标题标题标题标题标题？',
        showTime: '2021-01-22 10:21:01',
      }],
      list: [],
      nativeData: {},
      fundCode: '',
      fundType: '',
      tipstring: '',
    };
  },
  computed: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    getmmmmm() {
      return true;
    },
    clickAsk() {
      const bzLink = { LinkType: '2', LinkTo: `fund://mp.1234567.com.cn/weex/516939c37bdb4ba2b1138c50cf69a2e1/pages/FundDynamic/FundSendNote?fundCode=${this.fundCode}` };
      const { LinkType, LinkTo } = bzLink;
      detailPushPage({
        type: LinkType,
        url: LinkTo,
      });
      // 打点
      this.reportMonitor({
        eventName: 'pz.bz.tjbz.click',
      });
    },
    render() {
      this.nativeData = this.$store.state.native.fund;
      this.fundCode = this.nativeData.fundCode;
      this.fundType = this.nativeData.fundType;
      this.fetchRequest();
    },
    fetchCache() {
      const ca = this.$store.state.quotation.fund[`${this.fundCode}UserDynamicListCode`];
      this.list = ca;
    },
    fetchRequest() {
      this.$store.dispatch('updateUserDynamicListCode', this.fundCode).then((res) => {
        console.log('updateUserDynamicListCode');
        console.log(res);
        this.list = res;
      }).catch(() => {
        this.list = [];
      });
    },
    getTime(item) {
      const res = Util.formatTimeString(item.showTime);
      return res;
    },
    clickCell(item) {
      // const { linkType, linkTo } = item.link;
      // detailPushPage({
      //   type: linkType,
      //   url: linkTo,
      // });
      const {
        typeId,
        content,
        showTime,
        type,
      } = item;
      detailPushPage({
        appId: '516939c37bdb4ba2b1138c50cf69a2e1',
        url: '/pages/FundDynamic/FundDynamicDetial',
        params: {
          typeId,
          content,
          time: showTime,
          type,
        },
      });
      // 打点
      this.reportMonitor({
        eventName: 'pz.bz.djbz.click',
      });
    },
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      const bzLink = { LinkType: '2', LinkTo: `fund://mp.1234567.com.cn/weex/516939c37bdb4ba2b1138c50cf69a2e1/pages/SelfFundDynamicHome?fundCode=${this.fundCode}&fundName=${name}` };
      const { LinkType, LinkTo } = bzLink;
      detailPushPage({
        type: LinkType,
        url: LinkTo,
      });
      // 打点
      this.reportMonitor({
        eventName: 'pz.bz.gdbz.click',
      });
    },
  },
};
</script>

<style scoped lang="less">
.mianv{
  margin-left: 24px;
  margin-right: 24px;
  margin-bottom: 24px;
  background: #fff;
  border-radius: 12px;
}
.announcement {
  background-color: #ffffff;
  margin-left: 24px;
  padding-top: 30px;
  padding-bottom: 30px;
  padding-right: 24px;
  &:nth-last-child(1) {
    &:after{
      display: none;
    }
  }

  &-text {
    display: block; /* Fallback for non-webkit */
    text-overflow: ellipsis;
    font-size: 32px;
    color: #000000;
    text-align: left;
    line-height: 46px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  &-info {
    display: flex;
    align-items: center;
    margin-top: 16px;
  }

  &-tag {
    font-family: PingFangSC-Regular;
    font-size: 20px;
    color: #ff6434;
    line-height: 20px;
    padding: 4px 6px;
    border-radius: 4px;
    background-color: #fff1ec;
  }

  &-source {
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #999999;
    line-height: 28px;
    margin-left: 10px;
    margin-right: 20px;
  }

  &-time {
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #999999;
    line-height: 28px;
  }
  .spzModuleButton{
    margin-bottom: 4px;
  }
}
</style>
